import { Suspense } from "react"
import { Navigate, Outlet } from "react-router-dom"

import "@/pages/auth/style.scss"
import { useGlobal } from "@/app/store/global"
import { Spinner } from "@/shared/components"
import AuthLayout from "@/pages/auth/layout"

export const AuthGuard = () => {
  const isAuthorized = useGlobal(useGlobal.selectAuthState)

  if (isAuthorized) return <Navigate to="/dashboard" />
  return (
    <Suspense
      fallback={
        <div className="h-screen w-[100vw]">
          <Spinner />
        </div>
      }
    >
      <AuthLayout />
    </Suspense>
  )
}
